"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mongoose = tslib_1.__importStar(require("mongoose"));
const ethnicityInfoSchema = new mongoose.Schema({
    label: String,
    percentage: Number,
    rating: Number
});
const subRatingsSchema = new mongoose.Schema({
    'Test Scores Rating': Number,
    'Equity Overview Rating': Number,
    'Academic Progress Rating': Number,
    'College Readiness Rating': Number
});
const linksSchema = new mongoose.Schema({
    profile: String,
    reviews: String,
    collegeSuccess: String
});
const addressSchema = new mongoose.Schema({
    street1: String,
    street2: String,
    zip: String,
    city: String
});
const schoolSchema = new mongoose.Schema({
    id: {
        type: Number,
        index: true
    },
    districtId: {
        type: Number,
        index: true
    },
    compositeId: {
        type: String,
        index: true,
        unique: true
    },
    districtName: String,
    levelCode: String,
    lat: {
        type: Number,
        index: true
    },
    lon: {
        type: Number,
        index: true
    },
    name: {
        type: String,
        index: true
    },
    gradeLevels: {
        type: String,
        index: true
    },
    address: addressSchema,
    rating: {
        type: Number,
        index: true
    },
    ratingScale: String,
    schoolType: String,
    state: String,
    type: String,
    links: linksSchema,
    percentLowIncome: String,
    enrollment: Number,
    parentRating: Number,
    numReviews: Number,
    studentsPerTeacher: Number,
    subratings: subRatingsSchema,
    ethnicityInfo: [ethnicityInfoSchema],
    dateScraped: {
        type: Date,
        index: true
    }
});
const v1SchoolModel = mongoose.model('School', schoolSchema);
exports.v1SchoolModel = v1SchoolModel;
//# sourceMappingURL=School.model.js.map